module.exports = __webpack_public_path__ + "7ae8125a86811a21b75e3a78a7959348.png";